"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getters = {
    'ajax/lastFetchRequestKey': function (state) {
        return state.loading;
    }
};
var mutations = {
    'ajax/setLoading': function (state, key) {
        state.loading = key;
    }
};
exports.default = {
    getters: getters,
    mutations: mutations
};
//# sourceMappingURL=ajaxManagement.js.map